import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  leftMenuVisible: false
}

export const appToastSlice = createSlice({
  name: 'offcanvas',
  initialState,
  reducers: {
    showLeftMenu: (state, action) => {
      console.log(state, action)
      const {
        leftMenuVisible,
      } = action.payload
      state.leftMenuVisible = leftMenuVisible
    },
    hideLeftMenu: (state, action) => {
      state.leftMenuVisible = false
    }
  }
})

export const { showLeftMenu, hideLeftMenu } = appToastSlice.actions;


export default appToastSlice.reducer
